<template>
  <section id="functions">
    <description>Wählen Sie Plug-ins aus, die wir für Sie installieren und an Ihr Design anpassen.</description>
    <Swiper>
      <tile checkbox-id="kontaktformular" heading="Kontaktformular" input="checkbox" icon-id="kontaktformular" :contents="kontaktformularContent" :hints="kontaktformularHints" />
      <tile checkbox-id="bildergalerie" heading="Bildergalerien" input="checkbox" icon-id="bildergalerie" :contents="bildergalerieContent" :hints="bildergalerieHint" />
      <tile checkbox-id="cookies" heading="Cookie-Hinweis" input="checkbox" icon-id="cookies" :contents="cookiesContent" :hints="cookiesHint" />
      <tile checkbox-id="terminkalender" heading="Terminkalender" input="checkbox" icon-id="terminkalender" :contents="terminkalenderContent" :hints="terminkalenderHints" />
      <tile checkbox-id="googlemaps" heading="Google Maps" input="checkbox" icon-id="maps" :contents="googlemapsContent" :hints="googlemapsHint" />
      <tile checkbox-id="googleanalytics" heading="Google Analytics" input="checkbox" icon-id="analytics" :contents="googleanalyticsContent" :hints="googleanalyticsHint" />
      <tile checkbox-id="newsletter" heading="Newsletter" input="checkbox" icon-id="newsletter" :contents="newsletterContent" :hints="newsletterHints" />
    </Swiper>
    <controller :next="nextPageLink" prev="/sprachen" />
    <inclusive-footer />
    <how-to />
    <made />
  </section>
</template>

<script>
import Description from '@/components/Description.vue'
import Swiper from '@/components/Swiper.vue'
import Tile from '@/components/Tile.vue'
import Controller from '@/components/Controller.vue'
import HowTo from '@/components/HowTo.vue'
import InclusiveFooter from '@/components/InclusiveFooter.vue'
import Made from '@/components/Made.vue'
export default {
  components: {
    Description,
    Swiper,
    Tile,
    Controller,
    HowTo,
    InclusiveFooter,
    Made
  },
  data: function () {
    return {
      terminkalenderContent: [
        { sentence: 'Den Besuchern zeigen, wann Services verfügbar sind' },
        { sentence: 'Buchungen von Besuchern entgegennehmen und verwalten' }
      ],
      terminkalenderHints: [
        { sentence: 'Nehmen Sie Buchungen von Kunden entgegen wie beispielsweise Friseur- oder Wartungstermine' },
        { sentence: 'Im Buchungskalender beliebig viele Mitarbeiter, Tätigkeiten und Ressourcen anlegen' },
        { sentence: 'Geschäfts- und Arbeitszeiten sowie Pausen der einzelnen Mitarbeiter eintragen' },
        { sentence: 'Auf Wunsch mit PayPal als Bezahlungsmethode' },
        { sentence: 'Synchronisierbar von und zu Google Kalender' },
        { sentence: 'Bei Buchung automatisiert E-Mails oder SMS an Kunden und Mitarbeiter senden' }
      ],
      kontaktformularContent: [
        { sentence: 'Frei individualisierbares Kontaktformular, Änderungen ohne Programmierkenntnisse' },
        { sentence: 'Viele Felder wie Texteingabe oder Auswahlbuttons' }
      ],
      kontaktformularHints: [
        { sentence: 'Konfigurierbare Felder sind z. B. Texteingaben, Radio-Buttons, Checkboxen oder Datei-Uploads' },
        { sentence: 'Format der ausgehenden E-Mails ist frei individualisierbar' }
      ],
      newsletterContent: [
        { sentence: 'E-Mails von Besuchern abfragen und Newsletter erstellen' },
        { sentence: 'Ansprechende Newsletter ohne Programmierkenntnisse im CMS gestalten' }
      ],
      newsletterHints: [
        { sentence: 'E-Mails über Website abfragen oder im Back-End manuell eintragen' },
        { sentence: 'Interface zur Gestaltung der Newsletter ist voll im CMS intigriert' }
      ],
      bildergalerieContent: [
        { sentence: 'Bilder wie Mitarbeiter oder Referenzen attraktiv präsentieren' },
        { sentence: 'Galerien ganz einfach ohne Programmierkenntnisse selbst anlegen' }
      ],
      bildergalerieHint: [
        { sentence: 'Bildergalerie enthält eine Transition zwischen den einzelnen Bildern' },
        { sentence: 'Sie können im CMS beliebig viele Bildergalerien anlegen' }
      ],
      antispamContent: [
        { sentence: 'Deutliche Reduktion von Spam-Nachrichten' },
        { sentence: 'Nutzung von modernen Techniken wie Re-Captcha' }
      ],
      cookiesContent: [
        { sentence: 'Gesetzliche Pflicht zum Hinweis auf Cookies erfüllen' },
        { sentence: 'Kann u. U. Abmahnungen verhindern' }
      ],
      cookiesHint: [
        { sentence: 'Cookie-Hinweistext und Buttons (z. B. Link zur Datenschutzerklärung) frei im CMS individualisierbar' }
      ],
      googlemapsContent: [
        { sentence: 'Google Maps auf Ihrer Website einbinden' },
        { sentence: 'Besuchern den direkt Weg zu Ihrem Standort zeigen' }
      ],
      googlemapsHint: [
        { sentence: 'Google Maps sind über API grafisch individualisierbar' }
      ],
      googleanalyticsContent: [
        { sentence: 'Durch Analyse die Nutzer besser verstehen' },
        { sentence: 'Erkennen, welche Bereiche besonders beliebt sind oder wo nachgebessert werden muss' }
      ],
      googleanalyticsHint: [
        { sentence: 'Google Analytics Tag auf allen Seiten der Website' }
      ]
    }
  },
  computed: {
    nextPageLink: function () {
      if (this.$root.items.find(item => item.id === 'blogfunktion').status) {
        return '/blog'
      } else {
        if (this.$root.items.find(item => item.id === 'onlineshop').status) {
          return '/shop'
        } else {
          return '/technisches'
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "../assets/css/variables.scss";
#functions {
  padding-top: 80px;
  #description {
    padding: 0 15px;
    p {
      font-size: 18px;
    }
  }
}
@media (min-height: 420px) {
  #functions {
    padding-bottom: 107px;
  }
}
@media (min-height: 520px) {
  #functions {
    padding-bottom: 127px;
  }
}
@media(min-width:767px) {
  #functions {
    padding-top: 100px;
    #description {
      padding: 0 40px;
      p {
        font-size: 20px;
      }
    }
  }
}
</style>
